module.exports = __webpack_public_path__ + "img/bgLaborContract.a27542b7.png";